/**
 * The homepage track (2026-10-06 拍板): `/?t=young` or `/?t=parents` opens the
 * tree on that audience's lights (server: ember/tracks.js); everything else on
 * the page is the plain homepage. The name is kept for the tab (sessionStorage)
 * so a walk into the conversation and back to `/` — which carries no query —
 * stays on the track; a new tab without the query is the plain homepage.
 */
export type TrackName = 'young' | 'parents';

const TRACKS: readonly TrackName[] = ['young', 'parents'];
const KEY = 'ember.track';

function asTrack(value: string | null | undefined): TrackName | null {
  const v = String(value ?? '').trim().toLowerCase();
  return (TRACKS as readonly string[]).includes(v) ? (v as TrackName) : null;
}

/** The track this document is on: the query first, then what the tab remembers. */
export function currentTrack(): TrackName | null {
  if (typeof window === 'undefined') return null;
  const fromQuery = asTrack(new URLSearchParams(window.location.search).get('t'));
  if (fromQuery) {
    try { window.sessionStorage.setItem(KEY, fromQuery); } catch { /* private window: the query alone carries it */ }
    return fromQuery;
  }
  try { return asTrack(window.sessionStorage.getItem(KEY)); } catch { return null; }
}
